var map = {
	"./1.png": "a8b0",
	"./2.png": "c9ce",
	"./3.png": "d18d",
	"./4.png": "c090",
	"./5.png": "4c98",
	"./6.png": "7302",
	"./bg.png": "205b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e057";